import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-forgotsubcriber',
  templateUrl: './forgotsubcriber.component.html',
  styleUrls: ['./forgotsubcriber.component.sass']
})
export class ForgotsubcriberComponent implements OnInit {
  siteKey:string;
  forgotForm: FormGroup;
  public subscriberEmail: string = '';
  public status: number = 0;
  @Input() forgotPasawordStatus;
  @Input() email;
  @Input() subscriber;
  @Input() emailToSend;
  @Input() productType;
  public ResponseList;
  @Output() updateView = new EventEmitter<number>();
  @Output() updateSubscriber = new EventEmitter<number>();
  @Output() updateEmail = new EventEmitter<string>();
  @Output() updateEmailToSend = new EventEmitter<string>();
  @Output() updateQuestions = new EventEmitter<number>();
  @Output() updateTypeAccount = new EventEmitter<number>();
  public contAst: number;
  private externalLoginSearch;
  private source = '';
  constructor(private services: Service, private global: GlobalService, private loadingScreenService: LoadingScreenService,private formBuilder: FormBuilder, public AngularFireAnalytics:AngularFireAnalytics) {
    this.createForm();
    this.AngularFireAnalytics.setCurrentScreen("Olvido contraseña");
    this.AngularFireAnalytics.logEvent("OlvidoContrasena sesión-Screenview");
    this.siteKey=this.global.siteKey;
    this.externalLoginSearch = sessionStorage.getItem("externalLoginSearch");
  }

  ngOnInit() {
    this.contAst = 0;

    if (this.externalLoginSearch !== null) {
      if (this.externalLoginSearch.includes('source') && this.externalLoginSearch.includes('eWatch')) {
        this.source = 'eWatch';
      }
    }

    this.global.cleanExternalLoginPath();
  }
  private createForm() {
    this.forgotForm = this.formBuilder.group({
      subscriberEmail: ['', Validators.required],
      recaptcha:['',Validators.required]
    });
  }
  validarUser2() {
    if (!this.forgotForm.invalid) {
      if (this.subscriberEmail.length === 0) {
        this.global.notif('Debe colocar un Correo Electrónico o Número de Teléfono.');
      }
      else if (this.validateUsernameInput() === false) {
        this.global.notif('Debe ingresar un Correo Electrónico o Número de Teléfono válido.');
      }
      else {
        this.loadingScreenService.startLoading();
        this.services.getChallengeQuestions3(this.subscriberEmail, this.source).subscribe(
          data => {
          this.loadingScreenService.stopLoading();
          if (data.hasError == false) {
            this.productType = this.global.checkTypeAccount(data.accountType, data.accountSubType);
            this.email = data.email;
            while (this.email.charAt(this.contAst) != "@") {
              this.contAst++;
            }
            let emalEncripted = this.email.charAt(0);
            for (let index = 1; index < this.contAst - 2; index++) {
              emalEncripted = emalEncripted + "*";
            }
            for (let index = this.contAst - 1; index < this.email.length; index++) {
              emalEncripted = emalEncripted + this.email.charAt(index);
            }
            this.emailToSend = this.email;
            this.email = emalEncripted;
            this.ResponseList = data.ResponseList;
            if (this.ResponseList !== [] && this.ResponseList !== null) {
              this.forgotPasawordStatus = 2;
            }
            else {
              this.forgotPasawordStatus = 31;
            }
            this.subscriber = data.subscriber;
            this.updateView.emit(this.forgotPasawordStatus);
            this.updateEmail.emit(this.email);
            this.updateEmailToSend.emit(this.emailToSend);
            this.updateSubscriber.emit(this.subscriber);
            this.updateQuestions.emit(this.ResponseList);
            this.updateTypeAccount.emit(this.productType);
          }
          else {
            this.global.notif(data.errorDesc);
          }
        },
          error => {
            console.log('error', error);
            this.loadingScreenService.stopLoading();
            this.global.notif('Ha ocurrido un error, intente nuevamente mas tarde.')
          }

        );
      }
    }
  }

  validateUsernameInput() {
    let emailRegex = /^(?=[A-Z])[A-Z0-9_\-\.]+@(?=(([A-Z0-9_\-]+\.)+))\1[A-Z]{2,4}$/i;
    let expr = /^([0-9])*$/;
    return (emailRegex.test(this.subscriberEmail) || expr.test(this.subscriberEmail));
  }
}
